import ApiProvider from '../../core/api/ApiProvider';
import { IDictionary } from '../types/IDictionary';

class AppSettingsApiClient
{
    public async getApplicationSettings(): Promise<IDictionary<string>> {
        return await ApiProvider.get<IDictionary<string>>('appsettings/getApplicationSettings');
    }

    public async getConfiguration(): Promise<IDictionary<string>> {
        return await ApiProvider.get<IDictionary<string>>('appsettings/getConfiguration');
    }
}

export default new AppSettingsApiClient();